import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope rent
const scope = 'report'

export default {
  path: '/report',
  name: 'report',
  component: Layout,
  // redirect: '/report/newReport',
  redirect: '',
  meta: {
    title: '报表',
    icon: ''
  },
  children: [{
    path: 'newReport',
    name: 'newReport',
    component: _import(`${scope}/reportCenter`),
    meta: {
      title: '新出房业绩',
      icon: ''
    }
  },
  {
    path: 'relet',
    name: 'relet',
    component: _import(`${scope}/relet`),
    meta: {
      title: '续租报表',
      icon: ''
    }
  },
  // {
  //   path: 'roomStatus',
  //   name: 'roomStatus',
  //   component: _import(`${scope}/roomStatus`),
  //   meta: {title: '房态数据报表', icon: ''}
  // },
  // {
  //   path: 'business',
  //   name: 'business',
  //   component: _import(`${scope}/business`),
  //   meta: {title: '业务运营报表', icon: ''}
  // },
  // {
  //   path: 'invest',
  //   name: 'invest',
  //   component: _import(`${scope}/invest`),
  //   meta: {title: '投资数据报表', icon: ''}
  //   },
  /**
   * 房态数据(片区)
   */
  {
    path: 'houseStatus',
    name: 'houseStatus',
    component: _import(`${scope}/zoneHouseStatus`),
    meta: {
      title: '房态数据报表',
      icon: ''
    }
  },
  // ssf报表1
  {
    path: 'investmentBusiness',
    name: 'investmentBusiness',
    component: _import(`${scope}/investmentBusiness`),
    meta: {
      title: '投资业务报表',
      icon: ''
    }
  },
  // ssf报表2
  // {
  //   path: 'investmentPerformance',
  //   name: 'investmentPerformance',
  //   component: _import(`${scope}/investmentPerformance`),
  //   meta: {
  //     title: '投资绩效报表',
  //     icon: ''
  //   }
  // },
  // ssf报表3 综合管家月度绩效报表
  // {
  //   path: 'housekeeperMonth',
  //   name: 'housekeeperMonth',
  //   component: _import(`${scope}/housekeeperMonth`),
  //   meta: {
  //     title: '综合管家月度绩效报表',
  //     icon: ''
  //   }
  // },
  // ssf报表4
  // {
  //   path: 'tenantsBusiness',
  //   name: 'tenantsBusiness',
  //   component: _import(`${scope}/tenantsBusiness`),
  //   meta: {
  //     title: '租客端业务报表',
  //     icon: ''
  //   }
  // },
  // ssf报表5
  {
    path: 'projectBusiness',
    name: 'projectBusiness',
    component: _import(`${scope}/projectBusiness`),
    meta: {
      title: '项目经营报表',
      icon: ''
    }
  },
  // ssf报表6
  {
    path: 'tenantsOperation',
    name: 'tenantsOperation',
    component: _import(`${scope}/tenantsOperation`),
    meta: {
      title: '租客端运营报表',
      icon: ''
    }
  },
  {
    path: 'companyHouseStatus',
    name: 'companyHouseStatus',
    component: _import(`${scope}/companyHouseStatus`),
    meta: {
      title: '财务公司房态报表',
      icon: ''
    }
  },
  {
    path: 'unitOvernightRentalRate',
    name: 'unitOvernightRentalRate',
    component: _import(`${scope}/unitOvernightRentalRate`),
    meta: {
      title: '片区间夜出租率报表',
      icon: ''
    }
  },
  {
    path: 'companyOvernightRentalRate',
    name: 'companyOvernightRentalRate',
    component: _import(`${scope}/companyOvernightRentalRate`),
    meta: {
      title: '财务公司间夜出租率报表',
      icon: ''
    }
  },
  {
    path: 'unitNewSign',
    name: 'unitNewSign',
    component: _import(`${scope}/unitNewSign`),
    meta: {
      title: '片区新签间数',
      icon: ''
    }
  },
  {
    path: 'unitLease',
    name: 'unitLease',
    component: _import(`${scope}/unitLease`),
    meta: {
      title: '片区退租间数',
      icon: ''
    }
  },
  {
    path: 'companyLease',
    name: 'companyLease',
    component: _import(`${scope}/companyLease`),
    meta: {
      title: '财务公司退租间数',
      icon: ''
    }
  },
  {
    path: 'unitSigned',
    name: 'unitSigned',
    component: _import(`${scope}/unitSigned`),
    meta: {
      title: '片区签约间数',
      icon: ''
    }
  },
  {
    path: 'companySigned',
    name: 'companySigned',
    component: _import(`${scope}/companySigned`),
    meta: {
      title: '财务公司签约间数',
      icon: ''
    }
  },
  ]

}



// WEBPACK FOOTER //
// ./src/router/modules/report.js